import * as React from "react";
const SvgGeminiIcon = (props) => /* @__PURE__ */ React.createElement("svg", { fill: "currentColor", fillRule: "evenodd", height: 26.599999999999998, style: {
  flex: "0 0 auto",
  lineHeight: 1
}, viewBox: "0 0 24 24", width: 26.599999999999998, xmlns: "http://www.w3.org/2000/svg", color: "#fff", ...props }, /* @__PURE__ */ React.createElement("title", null, "Gemini"), /* @__PURE__ */ React.createElement("path", { d: "M12 24A14.304 14.304 0 000 12 14.304 14.304 0 0012 0a14.305 14.305 0 0012 12 14.305 14.305 0 00-12 12" }));
export default SvgGeminiIcon;
